export enum HotelBookType {
  DEFAULT = "default",
}

export const HOTEL_BOOK_TYPE = "hotelBookType";

export const CFAR_OFFER_TYPE = "cfarOfferType";
